module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('div', {
    staticClass: "section",
    attrs: {
      "id": "section007"
    }
  }, [_c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "poem_title1",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_2"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("How do you picture the shape of a year in your head")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Is a question my grandmother often asked.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The jog ends at the point where we watch the sun disappear.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("We drag sticks in the sand to spell out our names.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("To myself I write: Happy Birthday.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The few trees before the beach in silhouette.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The sky is red, the boats in the small harbor, docked.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("On the Rappahannock my grandparents moved to retire.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("As they aged, my mother rented herself this house.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Because the land is the same level as the water")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The house sits high up on stilts. At night, from bed,")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("The stars through the windows burn a circuit of lights.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("It all depends on where you start. A year is a circle,")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("If not a point around which experience spirals.")]), _vm._v(" "), _c('div', {
    staticClass: "pseudo_margin_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("Because our mother is gone, we do not need the house.")]), _vm._v(" "), _c('p', {
    staticClass: "negative_indent_1"
  }, [_vm._v("We tell ourselves this. Soon we will clean out inside.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7541ef56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter001.vue
// module id = 84
// module chunks = 0